import React from "react";
import { Box, CircularProgress } from "@mui/material";

/**
 * ==========================================================
 * PageLoader
 * ==========================================================
 *
 * Used for lazy-loaded pages (React Suspense fallback)
 *
 * ==========================================================
 */

const PageLoader = () => {

  return (

    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh"
      }}
    >

      <CircularProgress size={40} />

    </Box>

  );

};

export default PageLoader;
